const RequiredField = () => (
	<span className="p-mr-1" style={{ color: 'crimson' }}>
		(<i className="fad fa-asterisk" />)
	</span>
);

export default RequiredField;
